import * as React from 'react';
import { Button } from "../button";

var ScrollButton = function ScrollButton(_ref) {
  var _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'right' : _ref$direction,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? true : _ref$visible,
      onClick = _ref.onClick;
  return visible && /*#__PURE__*/React.createElement(Button, {
    icon: direction === 'left' ? 'arrow_chevron_left' : 'arrow_chevron_right',
    onClick: onClick,
    disabled: !visible,
    sx: {
      opacity: visible ? 1 : 0
    }
  });
};

export default ScrollButton;